
import { useEffect } from "react";
import { useToast } from "@/components/ui/use-toast";

export const useErrorToast = (error: string | null) => {
  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      toast({
        title: "Errore",
        description: "Si è verificato un errore nel caricamento dei post. Riprova più tardi.",
        variant: "destructive"
      });
    }
  }, [error, toast]);

  return { showToast: (message: string) => toast({ description: message }) };
};
